import { UpdatefirebaseService } from './../../services/updatefirebase.service';
import { FirebaseService } from './../../services/firebase.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Authenticationservice } from '../../services/authentication.service';
import DataTable from 'datatables.net-dt';

declare var $: any;
@Component({
  selector: 'app-addcutcanetype',
  templateUrl: './addcutcanetype.component.html',
  styleUrls: ['./addcutcanetype.component.css']
})
export class AddcutcanetypeComponent implements OnInit, OnDestroy {

  FormCutGroup: UntypedFormGroup;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('table02', { static: false }) table02Tb: any;

  constructor(private auth: Authenticationservice, private updatefirebase: UpdatefirebaseService, private spinner: NgxSpinnerService) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel
    this.FormCutGroup = new UntypedFormGroup({
      rootid: new UntypedFormControl(),
      zoneid: new UntypedFormControl(),
      cutseed: new UntypedFormControl(),
      selectconfirm: new UntypedFormControl(),
      canetypedate: new UntypedFormControl(),
      datestart: new UntypedFormControl(),
      datestop: new UntypedFormControl(),
    });
  }
  zone = '';
  supcode = '';
  userlv = '';
  fromDate: any; toDate: any;
  Check_not: boolean;
  text_f = '';
  text_f2 = '';

  ngOnInit(): void {
    this.LoadZone();
    //this.Check_not =false;
  }
  year_id = '2425'

  intDiff(i: number) {
    if (i < 0) {
      return i;
    } else if (i > 0) {
      return '+' + i;
    } else ''
  }
  dataSelect = ['ผลผลิตได้เกินเป้าหมาย', 'ผลผลิตได้ตามเป้าหมาย', 'ผลผลิตได้ต่ำกว่าเป้าหมาย'];

  compNums(a, b) {
    return a - b;
  }

  // โหลดข้อมูล zone
  zonecode: any;
  LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
      }).catch(err => { throw (err) })
  }

  // โหลดข้อมูลโดยกลุ่ม
  fmdata = [];
  fmbygroupdata = [];
  keppcode = [];
  edit_st = false;
  edit_st2 = false;
  type_select: number = 1;
  fmcode: string;

  // โหลดข้อมูลโดยโซน รูท
  @ViewChild('fmTable', { static: false }) fmTable: any;
  mydatatable: any;
  Loadfarmerdata() {
    console.log(this.mydatatable);
    this.fmbygroupdata = [];
    this.fmdata = [];
    let root = (this.FormCutGroup.get('rootid').value);
    let zone = (this.FormCutGroup.get('zoneid').value);

    if (this.keppcode != null || this.keppcode != undefined) {
      this.keppcode = [{ 'zone': zone, 'root': root }];
    }
    if (root == '' || root == undefined) { this.fmdata = []; this.fmbygroupdata = []; }
    else {
      this.LoadNewData();
    }
  }

  LoadNewData() {
    let type_s = this.type_select
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=CPS6263.dbo.v_cp6768_basic_a`
    if (type_s == 1) {
      let root = (this.FormCutGroup.get('rootid').value);
      let zone = (this.FormCutGroup.get('zoneid').value);
      url = url + `&w=supzone='${zone}'and[route]='${root}'order by[fmcode],[intlandno]`;
    }
    else if (type_s == 2) {
      let fmcode = this.fmcode
      url = url + `&w=fmcode='${fmcode}'order by[fmcode],[intlandno]`;
    }
    console.log('type_s:', type_s, url);
    this.spinner.show();
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      data = data.map(item => {
        return {
          ...item,
          modify: false,
          cutstart_edit: item.cutstart_sv,
          cutstop_edit: item.cutstop_sv,
          Cutseed_edit: item.BreedTon,
          docCheckCutF_edit: item.docCheckCutF,
          yieldDocCutF_edit: item.yieldDocCutF,
        };
      });
      this.fmbygroupdata = data;
      this.fmdata = data;

    }).catch(err => { throw (err) })
  }

  sum_sv = [];
  dataPlant = [];
  allDataPlant = [];
  newtable: any;
  LoadNewData2() {
    this.spinner.show();
    let zone = this.zone
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp6768_basic_a]&w=[cutstatus_sv]='F'and[supzone]='${zone}'order by[cutstop]desc`;
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      //this.sum_sv = data.map(function (el) { return el.supcode });
      this.sum_sv = ['All', ...new Set(data.map(function (elem) { return (elem.supcode) }))].sort(this.compNums);
      //console.log('sum_sv:', this.sum_sv);
      data = data.map(item => {
        return {
          ...item,
          modify: false,
        };
      });
      //this.dataPlant = data;
      this.allDataPlant = data;
      this.filterBySup('All');
    }).catch(err => { throw (err) })
  }
  sup: string;
  filterBySup(sup: string) {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    this.sup = sup;
    this.edit_st2 = false;
    if (sup == 'All') this.dataPlant = this.allDataPlant;
    else this.dataPlant = this.allDataPlant.filter((el: any) => el.supcode == sup);
    setTimeout(() => {
      this.newtable = $(this.table02Tb.nativeElement).DataTable({ order: [[0, 'desc']] });
    }, 100);
  }

  async saveData() {
    let root = (this.FormCutGroup.get('rootid').value);
    let zone = (this.FormCutGroup.get('zoneid').value);
    let data = this.fmdata.filter((el: any) => el.modify == true);
    console.log('modify:', data);

    if (data.length > 0) {
      if (confirm(`ต้องการบันทึกข้อมูล | จำนวน ${data.length} แปลง หรือไม่?`)) {
        this.spinner.show();
        for (let i = 0; i < data.length; i++) {
          let ar0 = data[i]
          //console.log(i, ', แปลง:', ar0.intlandno, ', datestart:', datestart, ', datestop:', datestop);

          //if (ar0.Cutseed_edit != ar0.Cutseed || ar0.Cutseed_edit != ar0.Cutseed) {
          //this.UpdateCutseed(ar0)
          this.UpdateCutstatus(ar0);
          //}
          //this.updatefirebase.updateCutStartBySupport(ar0.itid, this.year_id, datestart, datestop);          
          /*this.updatefirebase.updateareas(this.year_id, ar0.itid,
            { cutstart: datestart, cutstop: datestop, }
          );*/
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        alert("อัพเดทวันตัดแล้วค่ะ");
        setTimeout(() => {
          this.LoadNewData();
          this.edit_st = false;
          this.spinner.hide();
        }, 3500);
      }
    }
  }

  async saveDoc() {
    let data = this.dataPlant.filter((el: any) => el.modify == true);
    console.log('modify:', data);
    if (data.length > 0) {
      if (confirm(`ต้องการบันทึกข้อมูล | จำนวน ${data.length} แปลง หรือไม่?`)) {
        this.spinner.show();
        for (let i = 0; i < data.length; i++) {
          await new Promise(resolve => setTimeout(resolve, 500));
          let url: string, ar0 = data[i]
          this.Updateareas(ar0);
        }
        this.spinner.hide();
        this.LoadNewData2();
      }
    }
  }
  UpdateCutstatus(data) {
    let datestart = this.Datetokeep(data.cutstart_edit)
      , datestop = this.Datetokeep(data.cutstop_edit)
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?[itid]=${data.itid}&[cutstart_sv]=${datestart}&[cutstop_sv]=${datestop}&[docCheckCutF]=${data.docCheckCutF_edit || ''}&[yieldDocCutF]=${data.yieldDocCutF_edit || 0}`;
    console.log("UpdateCutstatus:", datestart, datestop, data);
    axios.post(url).then(res => {
      if (res.data.rowsAffected[0] > 0) { }
      else {
        alert(`อัพเดทข้อมูลแปลง ${data.intlandno} ไม่สำเร็จ`);
      }
    }).catch(err => { throw err })
  }
  // อัพเดทจำนวนพันธุ์ 
  UpdateCutseed(data) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?[itid]=${data.itid}&[Cutseed]=${data.Cutseed_edit}&[docCheckCutF]=${data.docCheckCutF_edit}&[yieldDocCutF]=${data.yieldDocCutF_edit}`;
    axios.post(url).then(res => {
      if (res.data.rowsAffected[0] > 0) { }
      else {
        alert(`อัพเดทข้อมูลแปลง ${data.intlandno} ไม่สำเร็จ`);
      }
    }).catch(err => { throw err })
  }

  //  
  Updateareas(data) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?[itid]=" + data.itid + "&[docCheckCutF]=" + data.docCheckCutF;
    axios.post(url).then(res => {
      if (res.data.rowsAffected[0] >= 1) {
      }
      else {
        alert('อัพเดทข้อมูล ไม่สำเร็จ');
      }
    }).catch(err => { throw err })
  }


  doAction(event: any) {
    this.Check_not = event.target.checked;
    console.log('event.target.checked:', event.target.checked);
  }


  // แปลงวันที่ไทย ไว้แสดงข้อมูล
  formatDate(date: any) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit"//, timeZone: 'UTC'
    };

    return date1.toLocaleString('th-TH', options);
  }

  // แปลงเป็น ค.ศ. ก่อนลง Firebase
  Datetokeep(date: any) {
    if (!date) return '';
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    // if (year <= 3000){ year = year - 543}
    // else { year >= 1990 }{year = year + 543}    

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [year, month, day].join('-');

  }

  ngOnDestroy(): void {
    this.fmdata = []
    this.fmbygroupdata = null
  }

}
